module.exports = __webpack_public_path__ + "960a7b5a2c2322b898007c4611cecfd0.svg";